import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@root/shared/service/translate.service";

/**
 * 一个通用的option服务
 * 用于缓存所有的下拉列表选项，并缓存
 * 采用单例模式，多个组件引用无需多次读取接口
 */
@Injectable({
  providedIn: "root",
})
export class OptionService {
  optionsOfHouseTag: Option[];

  optionsOfHouseGroup: Option[];
  optionsOfRoomType: Option[];
  optionsOfReservationChannel: Option[];
  optionsOfReservationTag: Option[];

  constructor(
    private http: HttpClient,
    private t: TranslateService,
  ) {
    this.initConfigOptions();
    this.initOptionsOfHouseGroup();
    this.initOptionsOfRoomType();
  }

  /** 获取设置-custom config里的所有选项 */
  initConfigOptions() {
    this.http.get("/api/house_status_setting/get").subscribe((rst: any) => {
      const data = rst.data;
      this.initOptionsOfHouseTag(data?.house_tag);
      this.initOptionsOfReservationChannel(data?.reservation_channel);
      this.initOptionsOfReservationTag(data?.tag_list);
    });
  }

  initOptionsOfHouseGroup() {
    this.http.get("/api/house_group/group_list").subscribe((rst: any) => {
      this.optionsOfHouseGroup = rst?.data?.list?.map((item) => ({
        label: item.name,
        value: item.group_id,
      }));
      this.optionsOfHouseGroup.unshift({
        label: this.t.t("word.any"),
        value: null,
      });
    });
  }

  initOptionsOfRoomType() {
    this.http.get("/api/house_type/all").subscribe((rst: any) => {
      this.optionsOfRoomType = rst?.data?.list?.map((item) => ({
        label: item.title,
        value: item.id,
      }));
    });
  }

  private initOptionsOfHouseTag(list) {
    this.optionsOfHouseTag = list?.map((item) => ({
      ...item,
      label: item.name,
      value: item.id,
    }));
  }

  private initOptionsOfReservationChannel(list) {
    this.optionsOfReservationChannel = list
      .filter((channel) => channel.delete_time === null)
      .map((c) => ({ label: c.channel_name, value: c.code }));
  }

  private initOptionsOfReservationTag(list) {
    this.optionsOfReservationTag = list
      .filter((tag) => tag.delete_time === null)
      .map((t) => ({ label: t.tag_name, value: t.id }));
  }
}
